import {
  GLOBAL_CONFIG,
  IS_DEVELOPMENT_ENV,
  IS_MAIN_DEPLOYMENT,
  IS_PLAYWRIGHT_CI,
  IS_PRODUCTION_DEPLOYMENT,
  IS_STAGING_DEPLOYMENT,
} from '@/config/environments.config'

export const ENABLE_TRACKING_IN_DEV_ENV = false
export const USE_TRACKING = !IS_PLAYWRIGHT_CI && (
  IS_PRODUCTION_DEPLOYMENT
  || IS_STAGING_DEPLOYMENT
  || IS_MAIN_DEPLOYMENT
  || (ENABLE_TRACKING_IN_DEV_ENV && IS_DEVELOPMENT_ENV)
)

export const USE_SENTRY = !IS_PLAYWRIGHT_CI && (IS_PRODUCTION_DEPLOYMENT || IS_MAIN_DEPLOYMENT || IS_STAGING_DEPLOYMENT)
export const USE_SEGMENT = !!(USE_TRACKING && GLOBAL_CONFIG.SEGMENT_KEY && GLOBAL_CONFIG.ENABLED_SEGMENT)
export const USE_GTM = !!(USE_TRACKING && GLOBAL_CONFIG.GTM_ID && GLOBAL_CONFIG.ENABLED_GTM)
export const NEXT_PUBLIC_ZARAZ_CONSENT_ENABLED = process.env.NEXT_PUBLIC_ZARAZ_CONSENT_ENABLED === 'true'
export const { AUTH_SECRET } = process.env

export const CALENDAR_TOOLTIPS_ENABLED = false
export const TIMESLOT_PRICING_ENABLED = true
export const TICKETS_REMAINING_THRESHOLD = 20

export const LOCKING_ENABLED = true
export const LOCK_PATH = '/lock'
export const LOCK_REDIRECT_PARAM = 'lock_redirect_to'
export const LOCK_EXPIRATION = 7200
